import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Action } from '@check-list/app/classes/models/action.model';

@Component({
  selector: 'authority-labs-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  @Input() menuActions: Action[];
  @Input() icon: string;
  @Input() title: string;
  @Input() buttonStyle: 'circle' | 'round';

  @Output() actionClick = new EventEmitter<Action>();

  constructor() {}

  onMenuClick(item: Action) {
    this.actionClick.emit(item);
  }
}
